module.exports = __webpack_public_path__ + "img/logo.17917246.png";